import React from "react";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/core";

import { ContentLoading } from './styles';
import { useTranslation } from "../../hooks/useTranslation";

interface LoadingProps {
    size: number;
    bShowText?: boolean;
    color?: string;
    loading?: boolean;
}

export const override = css`
  display: block;
  margin: 0 auto;
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;
`;

const Loading: React.FC<LoadingProps> = ({ size, bShowText = false, color = "var(--primary)", loading = true }: LoadingProps) => {
    const { onTranslation: t } = useTranslation();

    return (
        <ContentLoading>
            <PuffLoader color={color} loading={loading} css={override} size={size} />
            {
                bShowText && (<div><span>{t('main.globals.loading')}</span></div>)
            }
        </ContentLoading>
    )
}

export default Loading;